module.exports = __webpack_public_path__ + "b2fff9f71e97fd44852f961c6a49c2e9.mp4";